import {
  Companion_instance2bxh5k04i38vl as Companion_instance,
  Companion_instance3b2ql10d66of8 as Companion_instance_0,
  Nothing_getInstance2cox2iic6p9qw as Nothing_getInstance,
  Companion_instanceh1zhnl1id9u6 as Companion_instance_1,
  Companion_instance2xh5qtziumx9l as Companion_instance_2,
  Modification187ho6cz13sbh as Modification,
  Companion_instance30d6g5ap8rdfm as Companion_instance_3,
  Chainlkbkk6tcx8wg as Chain,
  IfNotNull2i0zh8hr8em4r as IfNotNull,
  Assign2nr5v5j409ffp as Assign,
  CoerceAtMost3d63rbc83rbza as CoerceAtMost,
  CoerceAtLeast1qec5fy91tzrc as CoerceAtLeast,
  Increment34m77r2mp8qrl as Increment,
  Multiply2vbqtqfo8ocrx as Multiply,
  AppendString3a1k249xx52p6 as AppendString,
  AppendRawString2twa0g1pq2wsh as AppendRawString,
  ListAppend2l1q2g9n9gupy as ListAppend,
  ListRemove2avniudn03c1m as ListRemove,
  ListRemoveInstances18gi59vc9xu0e as ListRemoveInstances,
  ListDropFirst3anrtu81y5hmf as ListDropFirst,
  ListDropLast3dtmf7u6qkj2m as ListDropLast,
  SetAppend2k79v2d727eg7 as SetAppend,
  SetRemove2xr7mvrx67bk4 as SetRemove,
  SetRemoveInstances32hzcc0ox5b27 as SetRemoveInstances,
  SetDropFirst3sc6ml7wbavtv as SetDropFirst,
  SetDropLast16suuclx5epig as SetDropLast,
  Combine39jly1szyd8uz as Combine,
  ModifyByKey26rgyr9ctzu42 as ModifyByKey,
  RemoveKeys34p6j7mjgfhm6 as RemoveKeys,
  Companion_instance3iz3lmuiwm4gs as Companion_instance_4,
  Companion_instance1803vszd3jkgu as Companion_instance_5,
  Companion_instance3jdqbmrdwjecn as Companion_instance_6,
  Companion_instance1stph8yw2qjt5 as Companion_instance_7,
  Companion_instance35mjssmfxcqi1 as Companion_instance_8,
  Companion_instance1cmtpto9j9iy1 as Companion_instance_9,
  Companion_instance1mmg08h7zlnuq as Companion_instance_10,
  Companion_instanceogftm8o6mnqa as Companion_instance_11,
  Companion_instance1za9qc8wkqj85 as Companion_instance_12,
  Companion_instancexixyq1cxutlm as Companion_instance_13,
  Companion_instance1thnnb3838mfv as Companion_instance_14,
  Companion_instance2992tql2kbmd as Companion_instance_15,
  Companion_getInstance3kmlqavk0jt8f as Companion_getInstance,
  Companion_instanceqw27e6orr13x as Companion_instance_16,
  Companion_instance3tbsu8lc454o8 as Companion_instance_17,
  Companion_instance3l6pokebxu46n as Companion_instance_18,
  Companion_instanceplmfjmw1b8eo as Companion_instance_19,
  Companion_instance1u3htj9m9i4vw as Companion_instance_20,
  Companion_getInstance15on8pfywvj4u as Companion_getInstance_0,
  OnFieldsnrykjjrmtcs as OnField,
  Nothing18o11lo0yw6xd as Nothing,
  SetPerElement1iju3wf4wq6tr as SetPerElement,
  ListPerElement1svj6v7vx2rkd as ListPerElement,
  Companion_instance3i2oc9fl7dqwb as Companion_instance_21,
} from './Modification.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Optionfkzl7z5pdoc9 as Option,
  MySealedClassSerializer11mxzpb8qyqe6 as MySealedClassSerializer,
  MySealedClassSerializerInterface2tzma5kn4becp as MySealedClassSerializerInterface,
} from './MySealedClassSerializer.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { plus310ted5e4i90h as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
  isNumberiramasdbon0i as isNumber,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  KSerializerKeys3rcxhak3gf5 as KSerializerKey,
  listElement2fr0t0e999y76 as listElement,
  mapValueElement74u0ojsosa2t as mapValueElement,
  nullElementzitp7se36veh as nullElement,
  WrappingSerializer3cq24ex5vrdbg as WrappingSerializer,
} from '../serialization/SerializationHelpers.mjs';
import { get_serializableProperties2tbouuwr11am9 as get_serializableProperties } from '../serialization/SerializableProperty.mjs';
import {
  contains3ue2qo8xhmpf1 as contains,
  substringBefore3n7kj60w69hju as substringBefore,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  LIST_getInstancey7k5h8d5cvxt as LIST_getInstance,
  MAP_getInstance3s1t6byguxmp9 as MAP_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstancejecdfbtr9cdw as Companion_getInstance_1 } from '../StringAlts.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { KSerializerWithDefault194z2ragoko00 as KSerializerWithDefault } from '../serialization/Defaults.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1x79l67jvwntn as serializer,
  serializer3u3hsxnenk49x as serializer_0,
  SetSerializert3lb0yy9iftr as SetSerializer,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  BooleanCompanionObject_instance29o5h9ajgjmec as BooleanCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  Companion_instancek13g6rikuawd as Companion_instance_22,
  Conditionuclxcm24fzd9 as Condition,
} from './Condition.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer_1 } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import {
  listOfvhqybd2zx248 as listOf_0,
  setOf1u3mizs95ngxo as setOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { setOf45ia9pnfhe90 as setOf_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_stringOptions() {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return stringOptions;
}
var stringOptions;
function get_cache() {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return cache;
}
var cache;
function get_numlist() {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return numlist;
}
var numlist;
function comparableOptions(inner) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(inner);
  var tmp_0 = Companion_instance.b2j(inner);
  var tmp_1 = new (Option())(tmp_0, VOID, VOID, comparableOptions$lambda);
  var tmp_2 = Companion_instance_0.b2j(inner);
  return plus(tmp, listOf([tmp_1, new (Option())(tmp_2, VOID, VOID, comparableOptions$lambda_0)]));
}
function commonOptions(inner) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = Nothing_getInstance().k2a();
  var tmp_0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  var tmp_1 = new (Option())(tmp_0, VOID, VOID, commonOptions$lambda);
  var tmp_2 = Companion_instance_1.b2j(inner);
  var tmp_3 = new (Option())(tmp_2, VOID, VOID, commonOptions$lambda_0);
  var tmp_4 = Companion_instance_2.b2j(inner);
  return listOf([tmp_1, tmp_3, new (Option())(tmp_4, VOID, VOID, commonOptions$lambda_1)]);
}
var ModificationSerializerClass;
function ModificationSerializer() {
  if (ModificationSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        var tmp = this;
        var tmp0 = get_cache();
        // Inline function 'kotlin.collections.getOrPut' call
        var key = KSerializerKey().p3t(inner);
        var value = tmp0.p3(key);
        var tmp_0;
        if (value == null) {
          var answer = new (MySealedClassSerializer())('com.lightningkite.lightningdb.Modification', () => {
            var tmp;
            if (!(nullElement(inner) == null)) {
              var tmp_0 = ensureNotNull(nullElement(inner));
              tmp = nullableOptions(isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE());
            } else if (substringBefore(inner.az().h10(), _Char___init__impl__6a9atx(47)) === 'kotlin.String') {
              tmp = get_stringOptions();
            } else if (get_numlist().t1(inner.az().h10())) {
              tmp = numberOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else if (Companion_getInstance_1().g3n_1.t1(inner.az().h10())) {
              tmp = rawStringOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else if (equals(inner.az().s11(), MAP_getInstance())) {
              tmp = stringMapOptions(ensureNotNull(mapValueElement(inner)));
            } else if (equals(inner.az().s11(), LIST_getInstance())) {
              tmp = contains(inner.az().h10(), 'Set') ? setOptions(ensureNotNull(listElement(inner))) : listOptions(ensureNotNull(listElement(inner)));
            } else if (!(get_serializableProperties(inner) == null)) {
              tmp = classOptionsReflective(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            } else {
              tmp = comparableOptions(isInterface(inner, KSerializer()) ? inner : THROW_CCE());
            }
            var r = tmp;
            return isInterface(r, KtList()) ? r : THROW_CCE();
          });
          tmp0.s3(key, answer);
          tmp_0 = answer;
        } else {
          tmp_0 = value;
        }
        var tmp_1 = tmp_0;
        tmp.h44_1 = isInterface(tmp_1, MySealedClassSerializerInterface()) ? tmp_1 : THROW_CCE();
        this.i44_1 = inner;
        var tmp_2 = this;
        // Inline function 'com.lightningkite.lightningdb.Nothing.invoke' call
        var this_0 = Nothing_getInstance();
        tmp_2.j44_1 = this_0 instanceof Modification() ? this_0 : THROW_CCE();
      }
      x3m() {
        return this.j44_1;
      }
      toString() {
        return 'ModificationSerializer(inner=' + toString(this.i44_1) + ')';
      }
      hashCode() {
        return hashCode(this.i44_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ModificationSerializer()))
          return false;
        if (!equals(this.i44_1, other.i44_1))
          return false;
        return true;
      }
      t3t() {
        return this.h44_1.t3t();
      }
      az() {
        return this.h44_1.az();
      }
      k44(encoder, value) {
        this.h44_1.oz(encoder, value);
      }
      oz(encoder, value) {
        return this.k44(encoder, value instanceof Modification() ? value : THROW_CCE());
      }
      pz(decoder) {
        return this.h44_1.pz(decoder);
      }
    }
    initMetadataForClass($, 'ModificationSerializer', VOID, VOID, [MySealedClassSerializerInterface(), KSerializerWithDefault()]);
    ModificationSerializerClass = $;
  }
  return ModificationSerializerClass;
}
var ModificationChainSerializerClass;
function ModificationChainSerializer() {
  if (ModificationChainSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Chain');
        this.o44_1 = inner;
      }
      b3u() {
        return ListSerializer(Companion_instance_3.b2j(this.o44_1));
      }
      p44(it) {
        return it.g42_1;
      }
      d3u(it) {
        return this.p44(it instanceof Chain() ? it : THROW_CCE());
      }
      q44(it) {
        return Chain().h42(it);
      }
      f3u(it) {
        return this.q44((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationChainSerializer');
    ModificationChainSerializerClass = $;
  }
  return ModificationChainSerializerClass;
}
var ModificationIfNotNullSerializerClass;
function ModificationIfNotNullSerializer() {
  if (ModificationIfNotNullSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('IfNotNull');
        this.u44_1 = inner;
      }
      b3u() {
        return Companion_instance_3.b2j(this.u44_1);
      }
      v44(it) {
        return it.i42_1;
      }
      d3u(it) {
        return this.v44(it instanceof IfNotNull() ? it : THROW_CCE());
      }
      w44(it) {
        return IfNotNull().j42(it);
      }
      f3u(it) {
        return this.w44(it instanceof Modification() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationIfNotNullSerializer');
    ModificationIfNotNullSerializerClass = $;
  }
  return ModificationIfNotNullSerializerClass;
}
var ModificationAssignSerializerClass;
function ModificationAssignSerializer() {
  if (ModificationAssignSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Assign');
        this.a45_1 = inner;
      }
      b3u() {
        return this.a45_1;
      }
      b45(it) {
        return it.k42_1;
      }
      d3u(it) {
        return this.b45(it instanceof Assign() ? it : THROW_CCE());
      }
      b3v(it) {
        return Assign().l42(it);
      }
      f3u(it) {
        return this.b3v((it == null ? true : !(it == null)) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationAssignSerializer');
    ModificationAssignSerializerClass = $;
  }
  return ModificationAssignSerializerClass;
}
var ModificationCoerceAtMostSerializerClass;
function ModificationCoerceAtMostSerializer() {
  if (ModificationCoerceAtMostSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('CoerceAtMost');
        this.f45_1 = inner;
      }
      b3u() {
        return this.f45_1;
      }
      g45(it) {
        return it.m42_1;
      }
      d3u(it) {
        return this.g45(it instanceof CoerceAtMost() ? it : THROW_CCE());
      }
      x3v(it) {
        return CoerceAtMost().n42(it);
      }
      f3u(it) {
        return this.x3v((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationCoerceAtMostSerializer');
    ModificationCoerceAtMostSerializerClass = $;
  }
  return ModificationCoerceAtMostSerializerClass;
}
var ModificationCoerceAtLeastSerializerClass;
function ModificationCoerceAtLeastSerializer() {
  if (ModificationCoerceAtLeastSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('CoerceAtLeast');
        this.k45_1 = inner;
      }
      b3u() {
        return this.k45_1;
      }
      l45(it) {
        return it.o42_1;
      }
      d3u(it) {
        return this.l45(it instanceof CoerceAtLeast() ? it : THROW_CCE());
      }
      x3v(it) {
        return CoerceAtLeast().p42(it);
      }
      f3u(it) {
        return this.x3v((!(it == null) ? isComparable(it) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationCoerceAtLeastSerializer');
    ModificationCoerceAtLeastSerializerClass = $;
  }
  return ModificationCoerceAtLeastSerializerClass;
}
var ModificationIncrementSerializerClass;
function ModificationIncrementSerializer() {
  if (ModificationIncrementSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Increment');
        this.p45_1 = inner;
      }
      b3u() {
        return this.p45_1;
      }
      q45(it) {
        return it.q42_1;
      }
      d3u(it) {
        return this.q45(it instanceof Increment() ? it : THROW_CCE());
      }
      r45(it) {
        return Increment().r42(it);
      }
      f3u(it) {
        return this.r45(isNumber(it) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationIncrementSerializer');
    ModificationIncrementSerializerClass = $;
  }
  return ModificationIncrementSerializerClass;
}
var ModificationMultiplySerializerClass;
function ModificationMultiplySerializer() {
  if (ModificationMultiplySerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Multiply');
        this.v45_1 = inner;
      }
      b3u() {
        return this.v45_1;
      }
      w45(it) {
        return it.t42_1;
      }
      d3u(it) {
        return this.w45(it instanceof Multiply() ? it : THROW_CCE());
      }
      r45(it) {
        return Multiply().u42(it);
      }
      f3u(it) {
        return this.r45(isNumber(it) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationMultiplySerializer');
    ModificationMultiplySerializerClass = $;
  }
  return ModificationMultiplySerializerClass;
}
var ModificationAppendStringSerializerClass;
function ModificationAppendStringSerializer() {
  if (ModificationAppendStringSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        ModificationAppendStringSerializer_instance = null;
        super('AppendString');
        ModificationAppendStringSerializer_instance = this;
      }
      b3u() {
        return serializer(StringCompanionObject_instance);
      }
      a46(it) {
        return it.v42_1;
      }
      d3u(it) {
        return this.a46(it instanceof AppendString() ? it : THROW_CCE());
      }
      n3y(it) {
        return AppendString().w42(it);
      }
      f3u(it) {
        return this.n3y((!(it == null) ? typeof it === 'string' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ModificationAppendStringSerializer');
    ModificationAppendStringSerializerClass = $;
  }
  return ModificationAppendStringSerializerClass;
}
var ModificationAppendStringSerializer_instance;
function ModificationAppendStringSerializer_getInstance() {
  if (ModificationAppendStringSerializer_instance === VOID)
    new (ModificationAppendStringSerializer())();
  return ModificationAppendStringSerializer_instance;
}
var ModificationAppendRawStringSerializerClass;
function ModificationAppendRawStringSerializer() {
  if (ModificationAppendRawStringSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor() {
        super('AppendString');
      }
      b3u() {
        return serializer(StringCompanionObject_instance);
      }
      e46(it) {
        return it.x42_1;
      }
      d3u(it) {
        return this.e46(it instanceof AppendRawString() ? it : THROW_CCE());
      }
      n3y(it) {
        return AppendRawString().y42(it);
      }
      f3u(it) {
        return this.n3y((!(it == null) ? typeof it === 'string' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationAppendRawStringSerializer', ModificationAppendRawStringSerializer);
    ModificationAppendRawStringSerializerClass = $;
  }
  return ModificationAppendRawStringSerializerClass;
}
var ModificationListAppendSerializerClass;
function ModificationListAppendSerializer() {
  if (ModificationListAppendSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ListAppend');
        this.i46_1 = inner;
      }
      b3u() {
        return ListSerializer(this.i46_1);
      }
      j46(it) {
        return it.z42_1;
      }
      d3u(it) {
        return this.j46(it instanceof ListAppend() ? it : THROW_CCE());
      }
      m3v(it) {
        return ListAppend().a43(it);
      }
      f3u(it) {
        return this.m3v((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListAppendSerializer');
    ModificationListAppendSerializerClass = $;
  }
  return ModificationListAppendSerializerClass;
}
var ModificationListRemoveSerializerClass;
function ModificationListRemoveSerializer() {
  if (ModificationListRemoveSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ListRemove');
        this.n46_1 = inner;
      }
      b3u() {
        return Companion_instance_22.b2j(this.n46_1);
      }
      o46(it) {
        return it.c43_1;
      }
      d3u(it) {
        return this.o46(it instanceof ListRemove() ? it : THROW_CCE());
      }
      v3u(it) {
        return ListRemove().d43(it);
      }
      f3u(it) {
        return this.v3u(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListRemoveSerializer');
    ModificationListRemoveSerializerClass = $;
  }
  return ModificationListRemoveSerializerClass;
}
var ModificationListRemoveInstancesSerializerClass;
function ModificationListRemoveInstancesSerializer() {
  if (ModificationListRemoveInstancesSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ListRemoveInstances');
        this.s46_1 = inner;
      }
      b3u() {
        return ListSerializer(this.s46_1);
      }
      t46(it) {
        return it.e43_1;
      }
      d3u(it) {
        return this.t46(it instanceof ListRemoveInstances() ? it : THROW_CCE());
      }
      m3v(it) {
        return ListRemoveInstances().f43(it);
      }
      f3u(it) {
        return this.m3v((!(it == null) ? isInterface(it, KtList()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListRemoveInstancesSerializer');
    ModificationListRemoveInstancesSerializerClass = $;
  }
  return ModificationListRemoveInstancesSerializerClass;
}
var ModificationListDropFirstSerializerClass;
function ModificationListDropFirstSerializer() {
  if (ModificationListDropFirstSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ListDropFirst');
        this.x46_1 = inner;
      }
      b3u() {
        return serializer_0(BooleanCompanionObject_instance);
      }
      y46(it) {
        return true;
      }
      d3u(it) {
        return this.y46(it instanceof ListDropFirst() ? it : THROW_CCE());
      }
      z46(it) {
        return ListDropFirst().g43();
      }
      f3u(it) {
        return this.z46((!(it == null) ? typeof it === 'boolean' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListDropFirstSerializer');
    ModificationListDropFirstSerializerClass = $;
  }
  return ModificationListDropFirstSerializerClass;
}
var ModificationListDropLastSerializerClass;
function ModificationListDropLastSerializer() {
  if (ModificationListDropLastSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ListDropLast');
        this.d47_1 = inner;
      }
      b3u() {
        return serializer_0(BooleanCompanionObject_instance);
      }
      e47(it) {
        return true;
      }
      d3u(it) {
        return this.e47(it instanceof ListDropLast() ? it : THROW_CCE());
      }
      z46(it) {
        return ListDropLast().h43();
      }
      f3u(it) {
        return this.z46((!(it == null) ? typeof it === 'boolean' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationListDropLastSerializer');
    ModificationListDropLastSerializerClass = $;
  }
  return ModificationListDropLastSerializerClass;
}
var ModificationSetAppendSerializerClass;
function ModificationSetAppendSerializer() {
  if (ModificationSetAppendSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('SetAppend');
        this.i47_1 = inner;
      }
      b3u() {
        return SetSerializer(this.i47_1);
      }
      j47(it) {
        return it.i43_1;
      }
      d3u(it) {
        return this.j47(it instanceof SetAppend() ? it : THROW_CCE());
      }
      k47(it) {
        return SetAppend().j43(it);
      }
      f3u(it) {
        return this.k47((!(it == null) ? isInterface(it, KtSet()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetAppendSerializer');
    ModificationSetAppendSerializerClass = $;
  }
  return ModificationSetAppendSerializerClass;
}
var ModificationSetRemoveSerializerClass;
function ModificationSetRemoveSerializer() {
  if (ModificationSetRemoveSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('SetRemove');
        this.o47_1 = inner;
      }
      b3u() {
        return Companion_instance_22.b2j(this.o47_1);
      }
      p47(it) {
        return it.l43_1;
      }
      d3u(it) {
        return this.p47(it instanceof SetRemove() ? it : THROW_CCE());
      }
      v3u(it) {
        return SetRemove().m43(it);
      }
      f3u(it) {
        return this.v3u(it instanceof Condition() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetRemoveSerializer');
    ModificationSetRemoveSerializerClass = $;
  }
  return ModificationSetRemoveSerializerClass;
}
var ModificationSetRemoveInstancesSerializerClass;
function ModificationSetRemoveInstancesSerializer() {
  if (ModificationSetRemoveInstancesSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('SetRemoveInstances');
        this.t47_1 = inner;
      }
      b3u() {
        return SetSerializer(this.t47_1);
      }
      u47(it) {
        return it.n43_1;
      }
      d3u(it) {
        return this.u47(it instanceof SetRemoveInstances() ? it : THROW_CCE());
      }
      k47(it) {
        return SetRemoveInstances().o43(it);
      }
      f3u(it) {
        return this.k47((!(it == null) ? isInterface(it, KtSet()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetRemoveInstancesSerializer');
    ModificationSetRemoveInstancesSerializerClass = $;
  }
  return ModificationSetRemoveInstancesSerializerClass;
}
var ModificationSetDropFirstSerializerClass;
function ModificationSetDropFirstSerializer() {
  if (ModificationSetDropFirstSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('SetDropFirst');
        this.y47_1 = inner;
      }
      b3u() {
        return serializer_0(BooleanCompanionObject_instance);
      }
      z47(it) {
        return true;
      }
      d3u(it) {
        return this.z47(it instanceof SetDropFirst() ? it : THROW_CCE());
      }
      z46(it) {
        return SetDropFirst().p43();
      }
      f3u(it) {
        return this.z46((!(it == null) ? typeof it === 'boolean' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetDropFirstSerializer');
    ModificationSetDropFirstSerializerClass = $;
  }
  return ModificationSetDropFirstSerializerClass;
}
var ModificationSetDropLastSerializerClass;
function ModificationSetDropLastSerializer() {
  if (ModificationSetDropLastSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('SetDropLast');
        this.d48_1 = inner;
      }
      b3u() {
        return serializer_0(BooleanCompanionObject_instance);
      }
      e48(it) {
        return true;
      }
      d3u(it) {
        return this.e48(it instanceof SetDropLast() ? it : THROW_CCE());
      }
      z46(it) {
        return SetDropLast().q43();
      }
      f3u(it) {
        return this.z46((!(it == null) ? typeof it === 'boolean' : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationSetDropLastSerializer');
    ModificationSetDropLastSerializerClass = $;
  }
  return ModificationSetDropLastSerializerClass;
}
var ModificationCombineSerializerClass;
function ModificationCombineSerializer() {
  if (ModificationCombineSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('Combine');
        this.i48_1 = inner;
      }
      b3u() {
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_1(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        return MapSerializer(tmp$ret$1, this.i48_1);
      }
      j48(it) {
        return it.r43_1;
      }
      d3u(it) {
        return this.j48(it instanceof Combine() ? it : THROW_CCE());
      }
      k48(it) {
        return Combine().s43(it);
      }
      f3u(it) {
        return this.k48((!(it == null) ? isInterface(it, KtMap()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationCombineSerializer');
    ModificationCombineSerializerClass = $;
  }
  return ModificationCombineSerializerClass;
}
var ModificationModifyByKeySerializerClass;
function ModificationModifyByKeySerializer() {
  if (ModificationModifyByKeySerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('ModifyByKey');
        this.o48_1 = inner;
      }
      b3u() {
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_1(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        return MapSerializer(tmp$ret$1, Companion_instance_3.b2j(this.o48_1));
      }
      p48(it) {
        return it.u43_1;
      }
      d3u(it) {
        return this.p48(it instanceof ModifyByKey() ? it : THROW_CCE());
      }
      q48(it) {
        return ModifyByKey().v43(it);
      }
      f3u(it) {
        return this.q48((!(it == null) ? isInterface(it, KtMap()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationModifyByKeySerializer');
    ModificationModifyByKeySerializerClass = $;
  }
  return ModificationModifyByKeySerializerClass;
}
var ModificationRemoveKeysSerializerClass;
function ModificationRemoveKeysSerializer() {
  if (ModificationRemoveKeysSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(inner) {
        super('RemoveKeys');
        this.u48_1 = inner;
      }
      b3u() {
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer_1(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        return SetSerializer(tmp$ret$1);
      }
      v48(it) {
        return it.w43_1;
      }
      d3u(it) {
        return this.v48(it instanceof RemoveKeys() ? it : THROW_CCE());
      }
      w48(it) {
        return RemoveKeys().x43(it);
      }
      f3u(it) {
        return this.w48((!(it == null) ? isInterface(it, KtSet()) : false) ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationRemoveKeysSerializer');
    ModificationRemoveKeysSerializerClass = $;
  }
  return ModificationRemoveKeysSerializerClass;
}
function nullableOptions(inner) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(get_nullable(inner));
  var tmp_0 = Companion_instance_4.b2j(inner);
  return plus(tmp, listOf_0(new (Option())(tmp_0, VOID, VOID, nullableOptions$lambda)));
}
function numberOptions(serializer) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = comparableOptions(serializer);
  var tmp_0 = Companion_instance_5.b2j(serializer);
  var tmp_1 = new (Option())(tmp_0, VOID, VOID, numberOptions$lambda);
  var tmp_2 = Companion_instance_6.b2j(serializer);
  return plus(tmp, listOf([tmp_1, new (Option())(tmp_2, VOID, VOID, numberOptions$lambda_0)]));
}
function rawStringOptions(element) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = comparableOptions(element);
  var tmp_0 = Companion_instance_7.b2j(element);
  return plus(tmp, listOf_0(new (Option())(tmp_0, VOID, VOID, rawStringOptions$lambda)));
}
function stringMapOptions(element) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(MapSerializer(serializer(StringCompanionObject_instance), element));
  var tmp_0 = Companion_instance_8.b2j(element);
  var tmp_1 = new (Option())(tmp_0, VOID, VOID, stringMapOptions$lambda);
  var tmp_2 = Companion_instance_9.b2j(element);
  var tmp_3 = new (Option())(tmp_2, VOID, VOID, stringMapOptions$lambda_0);
  var tmp_4 = Companion_instance_10.b2j(element);
  return plus(tmp, listOf([tmp_1, tmp_3, new (Option())(tmp_4, VOID, VOID, stringMapOptions$lambda_1)]));
}
function setOptions(element) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(SetSerializer(element));
  var tmp_0 = Companion_instance_11.b2j(element);
  var tmp_1 = setOf('AppendSet');
  var tmp_2 = new (Option())(tmp_0, tmp_1, VOID, setOptions$lambda);
  var tmp_3 = Companion_instance_12.b2j(element);
  var tmp_4 = new (Option())(tmp_3, VOID, VOID, setOptions$lambda_0);
  var tmp_5 = Companion_instance_13.b2j(element);
  var tmp_6 = new (Option())(tmp_5, VOID, VOID, setOptions$lambda_1);
  var tmp_7 = Companion_instance_14.b2j(element);
  var tmp_8 = new (Option())(tmp_7, VOID, VOID, setOptions$lambda_2);
  var tmp_9 = Companion_instance_15.b2j(element);
  var tmp_10 = new (Option())(tmp_9, VOID, VOID, setOptions$lambda_3);
  var tmp_11 = Companion_getInstance().b2j(element);
  return plus(tmp, listOf([tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, new (Option())(tmp_11, VOID, VOID, setOptions$lambda_4)]));
}
function listOptions(element) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(ListSerializer(element));
  var tmp_0 = Companion_instance_16.b2j(element);
  var tmp_1 = setOf('AppendList');
  var tmp_2 = new (Option())(tmp_0, tmp_1, VOID, listOptions$lambda);
  var tmp_3 = Companion_instance_17.b2j(element);
  var tmp_4 = setOf('Remove');
  var tmp_5 = new (Option())(tmp_3, tmp_4, VOID, listOptions$lambda_0);
  var tmp_6 = Companion_instance_18.b2j(element);
  var tmp_7 = setOf('RemoveInstances');
  var tmp_8 = new (Option())(tmp_6, tmp_7, VOID, listOptions$lambda_1);
  var tmp_9 = Companion_instance_19.b2j(element);
  var tmp_10 = setOf('DropFirst');
  var tmp_11 = new (Option())(tmp_9, tmp_10, VOID, listOptions$lambda_2);
  var tmp_12 = Companion_instance_20.b2j(element);
  var tmp_13 = setOf('DropLast');
  var tmp_14 = new (Option())(tmp_12, tmp_13, VOID, listOptions$lambda_3);
  var tmp_15 = Companion_getInstance_0().b2j(element);
  var tmp_16 = setOf('PerElement');
  return plus(tmp, listOf([tmp_2, tmp_5, tmp_8, tmp_11, tmp_14, new (Option())(tmp_15, tmp_16, VOID, listOptions$lambda_4)]));
}
function classOptionsReflective(inner) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  var tmp = commonOptions(inner);
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = ensureNotNull(get_serializableProperties(inner));
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().u(this_0.length);
  var index = 0;
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var item = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp_0 = new (ModificationOnFieldSerializer())(item);
    var tmp_1 = item.bz();
    var tmp$ret$0 = new (Option())(tmp_0, VOID, tmp_1, classOptionsReflective$lambda(inner, _unary__edvuaz));
    destination.v(tmp$ret$0);
  }
  return plus(tmp, destination);
}
var ModificationOnFieldSerializerClass;
function ModificationOnFieldSerializer() {
  if (ModificationOnFieldSerializerClass === VOID) {
    class $ extends WrappingSerializer() {
      constructor(field) {
        super(field.i20());
        this.a49_1 = field;
      }
      b3u() {
        return Companion_instance_3.b2j(this.a49_1.h2j());
      }
      b49(it) {
        return it.z43_1;
      }
      d3u(it) {
        return this.b49(it instanceof OnField() ? it : THROW_CCE());
      }
      c49(it) {
        return OnField().a44(this.a49_1, it);
      }
      f3u(it) {
        return this.c49(it instanceof Modification() ? it : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ModificationOnFieldSerializer', VOID, VOID, [WrappingSerializer(), KSerializer()]);
    ModificationOnFieldSerializerClass = $;
  }
  return ModificationOnFieldSerializerClass;
}
function stringOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof AppendString();
}
function comparableOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof CoerceAtLeast();
}
function comparableOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof CoerceAtMost();
}
function commonOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Nothing();
}
function commonOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Chain();
}
function commonOptions$lambda_1(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Assign();
}
function nullableOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof IfNotNull();
}
function numberOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Increment();
}
function numberOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Multiply();
}
function rawStringOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof AppendRawString();
}
function stringMapOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof Combine();
}
function stringMapOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ModifyByKey();
}
function stringMapOptions$lambda_1(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof RemoveKeys();
}
function setOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetAppend();
}
function setOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetRemove();
}
function setOptions$lambda_1(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetRemoveInstances();
}
function setOptions$lambda_2(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetDropFirst();
}
function setOptions$lambda_3(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetDropLast();
}
function setOptions$lambda_4(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof SetPerElement();
}
function listOptions$lambda(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListAppend();
}
function listOptions$lambda_0(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListRemove();
}
function listOptions$lambda_1(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListRemoveInstances();
}
function listOptions$lambda_2(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListDropFirst();
}
function listOptions$lambda_3(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListDropLast();
}
function listOptions$lambda_4(it) {
  _init_properties_ModificationSerialization_kt__9j1qv2();
  return it instanceof ListPerElement();
}
function classOptionsReflective$lambda($inner, $index) {
  return (it) => {
    var tmp;
    if (it instanceof OnField()) {
      tmp = it.y43_1.i20() === $inner.az().v11($index);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
var properties_initialized_ModificationSerialization_kt_dvyy1w;
function _init_properties_ModificationSerialization_kt__9j1qv2() {
  if (!properties_initialized_ModificationSerialization_kt_dvyy1w) {
    properties_initialized_ModificationSerialization_kt_dvyy1w = true;
    var tmp = comparableOptions(serializer(StringCompanionObject_instance));
    var tmp_0 = Companion_instance_21.k2a();
    stringOptions = plus(tmp, listOf_0(new (Option())(tmp_0, VOID, VOID, stringOptions$lambda)));
    cache = HashMap().n8();
    numlist = setOf_0(['kotlin.Byte', 'kotlin.Short', 'kotlin.Int', 'kotlin.Long', 'kotlin.Float', 'kotlin.Double']);
  }
}
//region block: exports
export {
  ModificationAppendRawStringSerializer as ModificationAppendRawStringSerializeruylfpg2mbkb7,
  ModificationAssignSerializer as ModificationAssignSerializerysm6r8t6aqbz,
  ModificationChainSerializer as ModificationChainSerializer3eo283b0evyr4,
  ModificationCoerceAtLeastSerializer as ModificationCoerceAtLeastSerializer1tywcjfyjots,
  ModificationCoerceAtMostSerializer as ModificationCoerceAtMostSerializer2lyh2fkcuv7je,
  ModificationCombineSerializer as ModificationCombineSerializer2afeyhg59cg1i,
  ModificationIfNotNullSerializer as ModificationIfNotNullSerializer1sbx3dkpdrrqw,
  ModificationIncrementSerializer as ModificationIncrementSerializer2f5w496dzjgtq,
  ModificationListAppendSerializer as ModificationListAppendSerializer24hdf74drm9fb,
  ModificationListDropFirstSerializer as ModificationListDropFirstSerializersm4xxwngsfl4,
  ModificationListDropLastSerializer as ModificationListDropLastSerializerbns6ffxbuvwe,
  ModificationListRemoveInstancesSerializer as ModificationListRemoveInstancesSerializerupov89hctwev,
  ModificationListRemoveSerializer as ModificationListRemoveSerializer1cyj9g0hbaq08,
  ModificationModifyByKeySerializer as ModificationModifyByKeySerializerxlhu7pojz7sb,
  ModificationMultiplySerializer as ModificationMultiplySerializervdky5wcvbwoj,
  ModificationRemoveKeysSerializer as ModificationRemoveKeysSerializer2uyawkczz06wj,
  ModificationSerializer as ModificationSerializer3ubms8rrlijys,
  ModificationSetAppendSerializer as ModificationSetAppendSerializer5m15u4jowgug,
  ModificationSetDropFirstSerializer as ModificationSetDropFirstSerializer2g6vdsy7wrf51,
  ModificationSetDropLastSerializer as ModificationSetDropLastSerializer3eykhkeb9sfx1,
  ModificationSetRemoveInstancesSerializer as ModificationSetRemoveInstancesSerializer1avgdfaqi6nv2,
  ModificationSetRemoveSerializer as ModificationSetRemoveSerializerizso0ytsxizv,
  ModificationAppendStringSerializer_getInstance as ModificationAppendStringSerializer_getInstance33npjshy4ul8q,
};
//endregion

//# sourceMappingURL=ModificationSerialization.mjs.map
